import React from "react";
import { Box, ListItem, ListItemIcon, ListItemText, Typography } from "@mui/material";
import DoneAllIcon from "@mui/icons-material/DoneAll";

const ConvoClarification = (props) => {
  const { response } = props;

  const renderMatch = (match, index) => {
    const meaning = match.meaning || "";
    const score = match.is_exact ? "exact" : [match.scores[0].slice(0, 4)];
    const speech = match.character_speech;
    const userSpeech = match.user_speech;
    const discoveries = Array.isArray(match.discoveries) ? match.discoveries.join(", ") : "";
    const opportunities = Array.isArray(match.opportunities) ? match.opportunities.join(", ") : "";

    const primary = (
      <Box>
        <Typography variant="body2">
          <strong>User:</strong> {userSpeech}
        </Typography>
        <Typography variant="body2">
          <strong>Character:</strong> {speech}
        </Typography>
      </Box>
    );
    const secondary = (
      <Box sx={{ mt: 0.5, color: "text.secondary" }}>
        <Typography variant="caption" component="div">
          Score: {score}
        </Typography>
        <Typography variant="caption" component="div">
          Meaning: {meaning}
        </Typography>
        <Typography variant="caption" component="div">
          Discoveries: {discoveries}
        </Typography>
        <Typography variant="caption" component="div">
          Opportunity Ids: {opportunities}
        </Typography>
      </Box>
    );

    if (index === 0) {
      return (
        <ListItem key={index} alignItems="flex-start" sx={{ borderBottom: "1px solid", borderColor: "divider" }}>
          <ListItemIcon sx={{ minWidth: 36, mt: 1 }}>
            <DoneAllIcon color="info" fontSize="small" />
          </ListItemIcon>
          <ListItemText disableTypography primary={primary} secondary={secondary} />
        </ListItem>
      );
    } else {
      return (
        <ListItem key={index} alignItems="flex-start" sx={{ borderBottom: "1px solid", borderColor: "divider", pl: 9 }}>
          <ListItemText disableTypography primary={primary} secondary={secondary} />
        </ListItem>
      );
    }
  };

  return <>{response.Answer.matches.map((m, i) => renderMatch(m, i))}</>;
};

export default ConvoClarification;
